"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
function IconEyeClose(_a) {
    var width = _a.width, height = _a.height, className = _a.className;
    return (react_1.default.createElement("svg", { className: "icon ".concat(className), height: "".concat(height), viewBox: '0 0 20 15', width: "".concat(width) },
        react_1.default.createElement("path", { d: 'M19.9802 7.37273C18.5629 2.96269 14.5521 0 9.99998 0C5.4479 0 1.43708 2.96269 0.0198342 7.37273C-0.0066114 7.45535 -0.0066114 7.54484 0.0198342 7.62746C1.43708 12.0375 5.44794 15.0002 10 15.0002C14.5521 15.0002 18.5629 12.0375 19.9802 7.62746C20.0066 7.54484 20.0066 7.45535 19.9802 7.37273ZM9.99998 13.3335C6.78338 13.3335 4.1666 10.7167 4.1666 7.50012C4.1666 4.28356 6.78342 1.66674 9.99998 1.66674C13.2165 1.66674 15.8334 4.28356 15.8334 7.50012C15.8334 10.7167 13.2166 13.3335 9.99998 13.3335Z', fill: 'black' }),
        react_1.default.createElement("path", { d: 'M9.99998 10.8335C11.8409 10.8335 13.3333 9.34106 13.3333 7.5001C13.3333 5.65914 11.8409 4.16675 9.99998 4.16675C8.15902 4.16675 6.66663 5.65914 6.66663 7.5001C6.66663 9.34106 8.15902 10.8335 9.99998 10.8335Z', fill: 'black' })));
}
IconEyeClose.propTypes = {
    width: prop_types_1.default.number,
    height: prop_types_1.default.number,
    className: prop_types_1.default.string,
};
IconEyeClose.defaultProps = {
    width: 64,
    height: 64,
};
exports.default = IconEyeClose;
